import { DTO__base } from '@shared/common/DTO__base';
import { TYPE_CLASS_CONSTRUCTOR_DTO } from '@shared/types/types';
import { FN_SERIALIZATION__register_class } from './FN_SERIALIZATION__register_class';

export function FN_SERIALIZATION__register_class_dto(class_object: TYPE_CLASS_CONSTRUCTOR_DTO<DTO__base>) {
  FN_SERIALIZATION__register_class(class_object._class_name_static, class_object);
}
